export default {
  strict: true,
  namespaced: true,
  state: {
    availability: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'startShift',
      orderAsc: 1,
      loading: false,
      sector: 0,
      since: '',
      until: '',
      type: '',
      vehicleType: '',
      service: '',
      assignedTrips: '',
      checked: [],
      noShift: {
        list: [],
        order: 'name',
        orderAsc: 1,
        perPage: 20,
        currentPage: 1,
        maxList: 0
      }
    },
    sectors: {
      list: [],
      loading: false
    }
  },
  mutations: {
    resetAvailabilityList (state) { state.availability.list = [] },
    setAvailabilityList (state, value) { state.availability.list = value },
    setAvailabilityMaxList (state, value) { state.availability.maxList = value },
    setAvailabilityCurrentPage (state, value) { state.availability.currentPage = value },
    setAvailabilityPerPage (state, value) { state.availability.perPage = value },
    setAvailabilityOrder (state, value) { state.availability.order = value },
    setAvailabilityOrderAsc (state, value) { state.availability.orderAsc = value },
    setAvailabilityIsLoading (state, value) { state.availability.loading = value },
    setAvailabilitySector (state, value) { state.availability.sector = value },
    setSectorsList (state, value) { state.sectors.list = value },
    setSectorLoading (state, value) { state.sectors.loading = value },
    setAvailabilitySince (state, value) { state.availability.since = value },
    setAvailabilityUntil (state, value) { state.availability.until = value },
    setAvailabilityType (state, value) { state.availability.type = value },
    setAvailabilityService (state, value) { state.availability.service = value },
    setAvailabilityAssignedTrips (state, value) { state.availability.assignedTrips = value },
    setAvailabilityChecked (state, value) { state.availability.checked = value },
    setAvailabilityData (state, data) {
      for (let field in data) {
        state.availability[field] = data[field]
      }
    },
    setAvailabilityNoShiftData (state, data) {
      for (let field in data) {
        state.availability.noShift[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/provider/availability.js